module.exports = "../dist/frontend/icons/ui/writeUs.svg?78df70f9c21d5419b749998d35dc177f";